export default class FullScreenConfirmDialogCtrl {
  constructor(ngDialog) {
    this.ngDialog = ngDialog;
  }

  $onClick(dialogRef) {
    this.ngDialog.close(dialogRef);
  }
}
